module.exports = __webpack_public_path__ + "img/error.74f3b387.png";